import AdvanceEntryPoint from 'features/advance/screens/AdvanceEntry/AdvanceEntryPoint';
import React from 'react';

export default function About() {
  return <AdvanceEntryPoint />;
}
